<template>
  <div>
    <pvd-modal ref="fdic-modal" id="fdic-modal" pvd-modal-width="600" pvd-z-index="9999999">
      <div class="pvd-modal__heading">
        <h3 id="fdic-info">
          {{ clientConstants.FDIC_LINK }}
        </h3>
      </div>
      <p>
        {{ clientConstants.FDIC_INFO }}
        <pvd-link data-cy="fdic-gov" :pvd-href="fdicLink" pvd-new-window>{{ clientConstants.FDIC_URL }}</pvd-link>
      </p>
    </pvd-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core';
import { ClientConstants } from './../client.constants';
import { PvdModal } from '@fmr-ap109253/apex-kit/dist/lib/src/pvd';

declare let app: any;

export default defineComponent({
  name: 'FdicModal',
  data: function () {
    return {
      clientConstants: ClientConstants,
      fdicLink: ''
    };
  },
  methods: {
    openFdicModal() {
      const fdicModal = this.$refs['fdic-modal'] as PvdModal;
      fdicModal.pvdOpen = true;
    }
  },
  async mounted() {
    this.fdicLink = app ? `${app.fdicUrl}` : '';
  }
});
</script>
